module.exports = __webpack_public_path__ + "static/media/earnedInADay_10000_15000.9c63b752.png";